import { Space, Select } from 'antd';
import classnames from 'classnames';
import { Dispatch, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAdminServiceList,
  // g6Arrange,
  getServiceApprovalList,
  getUserIdList,
  // putServiceApproval,
  putServiceBatchApproval,
} from '../../../api';
import { getLocalTime } from '../../../lib';
import {
  CommonStatusStep,
  IAPIApproveGameListItem,
  IAPIServiceConfigItem,
  IAPIServicesApproveItem,
  ServiceBusiness,
} from '../../../model/api-modules';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
// import { AssistAddEnv } from './components/assist-open';
import { ColumnType } from 'antd/lib/table';
import { getEnvNameByValue } from '../../utils/env';
import { IServiceBatchApprovalParams } from '../../../model/api-modules/env';
import moment from 'moment';
import {
  messageError,
  // messageError,
  messageSuccess,
} from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import { IServicesApproveItem } from '../../../model/service';
import { ServiceResolveModal } from './resolve-modal';
import { BatchDrawer } from './batch-drawer';
// import { fetchAdminEnvList } from '../../../api/admin/game';
// import EnvDevIcon from '../../../assets/img/env-dev-icon.png';
// import EnvLiveIcon from '../../../assets/img/env-live-icon.png';
import { AutoAntTable } from '../../../components/auto-ant-table';
import {
  ICommonSupportPageProps,
  RbacRoleType,
  WindowEvent,
} from '../../../model';
import { wrapRequestArea } from '../../../lib/http/lib';
import { ModalWrap } from '../../../components/modal-wrap';
import { getEnvTypeOptions, renderEnvTypeTag } from '../../lib';
import {
  ApplyServiceStatus,
  getApplyServiceStatusOptions,
  getFormatServiceStatus,
  getServiceStatusLabel,
} from './lib';
import { CustomPopover } from '../../../components/custom-popover';
import { getSiteConfigs } from '../../../lib/app';
import { getUserNameBySite } from '../lib/columns';
import { uniq } from 'lodash';
import { getSupportRoleList, getSupportUsers } from '../../../api/admin/rbac';
import { IAdminMemberItem } from '../organization-manage/members';
import { IRootState } from '../../../store/reducers';

enum DrawerType {
  View = 'view',
  Approve = 'approve',
}

export const AdminService = (props: ICommonSupportPageProps) => {
  const { site } = props;
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const [serviceList, setServiceList] = useState<IServicesApproveItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [showResolveModal, setShowResolveModal] = useState<boolean>(false);
  const [showG6ResolveModal, setShowG6ResolveModal] = useState<boolean>(false);

  const [selectedRowKey, setSelectedRowKey] = useState<number>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  const [servicesConfig, setServicesConfig] = useState<IAPIServiceConfigItem[]>(
    []
  );
  const [selectGameAndEnv, setSelectGameAndEnv] = useState<
    Record<string, string | Number>
  >({});
  const [isShowBatchDrawer, setIsShowBatchDrawer] = useState<boolean>(false);
  const [showRejectModal, setShowRejectModal] = useState<boolean>(false);
  const [isFeeEnabled, setIsFeeEnabled] = useState<boolean>(false);
  const [drawerType, setDrawerType] = useState<DrawerType | null>(null);
  const [isAllSelectChecked, setIsAllSelectChecked] = useState<boolean>(false);
  const [isAllSelectIndeterminate, setIsAllSelectIndeterminate] =
    useState<boolean>(false);
  const [showNoDeployConfirmModal, setShowNoDeployConfirmModal] =
    useState<boolean>(false);
  const childRef = useRef<{
    onClickOk: (isNoDeployEnabled: boolean) => Promise<void>;
  } | null>(null);
  const [gameList, setGameList] = useState<IAPIApproveGameListItem[]>([]);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  // 筛选后的数据列表
  const [filteredServiceList, setFilteredServiceList] = useState<
    IServicesApproveItem[]
  >([]);

  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.ServiceApplication,
  });

  useEffect(() => {
    initFeeCenter();
    getSupportUsersList();
  }, []);

  const getSupportUsersList = async () => {
    const [roles, allUserRes, supportMembers] = await Promise.all([
      getSupportRoleList(),
      getUserIdList(),
      getSupportUsers(),
    ]);
    if (roles && allUserRes && supportMembers) {
      const members = supportMembers
        .map((item) => {
          const userId = item.UserID;
          return {
            userName:
              allUserRes.find((user) => user.UserID === userId)?.UserName ||
              item.UserName ||
              '',
            email: userId,
            inviter: item.InviterUserID,
            roles: roles
              .filter((role) => role.userList.includes(userId))
              .map((role) => {
                return { name: role.roleName, type: role.type };
              }),
          };
        })
        .sort((a, b) => {
          const sortMap = [
            RbacRoleType.Custom,
            RbacRoleType.Admin,
            RbacRoleType.Owner,
          ];

          const getMaxRole = (member: IAdminMemberItem) => {
            return member.roles.length
              ? Math.max(
                  ...member.roles.map((role) => sortMap.indexOf(role.type))
                )
              : 0;
          };

          const aMaxRole = getMaxRole(a);
          const bMaxRole = getMaxRole(b);

          return aMaxRole < bMaxRole ? 1 : -1;
        });
      const isSuper = members
        .find((member) => member.email === userInfo?.UserID)
        ?.roles.some((role) => role.type === RbacRoleType.Owner);
      const isAdm = members
        .find((member) => member.email === userInfo?.UserID)
        ?.roles.some((role) => role.type === RbacRoleType.Admin);
      if (isSuper || isAdm) {
        setIsAdmin(true);
      }
    }
  };

  const getDisabled = (pic: string | undefined) => {
    if (isAdmin) {
      return false;
    }
    if (userInfo?.UserID && pic && pic.includes(userInfo?.UserID)) {
      return false;
    }
    return true;
  };

  const initFeeCenter = async () => {
    const config = await getSiteConfigs(site);
    setIsFeeEnabled(config?.feeCenter?.enabled || false);
  };

  useEffect(() => {
    if (selectedRowKeys.length !== 0) {
      const selectItem = serviceList.find(
        (item) => item.id === selectedRowKeys[0]
      );
      const selectAbled = serviceList.filter((item) => {
        const serviceItem = servicesConfig.find(
          (it) => it.Name === item.ServiceName
        );
        const isG6 = serviceItem?.Business === ServiceBusiness.G6;
        const isDisabled =
          item.Status !== CommonStatusStep.Pending ||
          (item.Status === CommonStatusStep.Pending &&
            item.Deployed !== CommonStatusStep.Pending);
        return (
          item.GameID === selectItem?.GameID &&
          item.EnvID === selectItem?.EnvID &&
          isG6 &&
          !isDisabled &&
          item.FeeOrderApproved === null &&
          !getDisabled(serviceItem.Pic)
        );
      });
      if (selectAbled && selectAbled.length !== 0) {
        setIsAllSelectChecked(
          selectedRowKeys.length > 0 &&
            selectedRowKeys.length === selectAbled.length
        );
        setIsAllSelectIndeterminate(
          selectedRowKeys.length > 0 &&
            selectedRowKeys.length < selectAbled.length
        );
      }
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    noticeUnApproveNumber();
  }, [serviceList]);

  const compactServiceList = (
    list: IAPIServicesApproveItem[] | null
  ): IServicesApproveItem[] => {
    if (!list) {
      return [];
    }
    const serviceMap = list.reduce<Record<string, IServicesApproveItem>>(
      (acc, serviceItem) => {
        if (serviceItem.Status !== CommonStatusStep.Pending) {
          return acc;
        }
        const key = `${serviceItem.EnvID}-${serviceItem.ServiceID}`;
        const currentService = acc[key];

        if (currentService) {
          currentService.SubServiceName = `${acc[key].SubServiceName} ${
            serviceItem.SubServiceName ? `,${serviceItem.SubServiceName}` : ''
          }`;
          currentService.relatedApproveIds =
            currentService.relatedApproveIds || [];
          currentService.relatedApproveIds.push(serviceItem.id);
        } else {
          acc[key] = serviceItem;
          acc[key].relatedApproveIds = [serviceItem.id];
        }
        return acc;
      },
      {}
    );

    const formatPendingList = Object.values(serviceMap).sort((a, b) =>
      a.id < b.id ? 1 : -1
    );
    return [
      ...formatPendingList,
      ...list.filter((item) => item.Status !== CommonStatusStep.Pending),
    ];
  };

  const noticeUnApproveNumber = () => {
    if (!site) {
      return;
    }
    const pendingList = serviceList.filter(
      (item) =>
        item.Status === CommonStatusStep.Pending &&
        item.Deployed !== CommonStatusStep.Resolve
    );
    window.dispatchEvent(
      new CustomEvent(WindowEvent.SiteTabBadge, {
        detail: { [site]: pendingList.length },
      })
    );
  };

  // 获取审批列表
  const getApprovalList = async () => {
    setLoading(true);
    const [serviceListRes, result] = await Promise.all([
      wrapRequestArea(getServiceApprovalList, site),
      wrapRequestArea(getAdminServiceList, site),
    ]);
    if (serviceListRes?.list) {
      const res = compactServiceList(serviceListRes.list);
      if (res && result) {
        setServiceList(res);
        setServicesConfig(result);
        setGameList(serviceListRes.gameList);
      }
      setLoading(false);
    }
  };

  // 获取可选的数据项（用于全选判断）
  const getSelectableItems = (list: IServicesApproveItem[]) => {
    const selectItem = list.find((item) => item.id === selectedRowKeys[0]);
    return list.filter((item) => {
      const serviceItem = servicesConfig.find(
        (it) => it.Name === item.ServiceName
      );
      const isG6 = serviceItem?.Business === ServiceBusiness.G6;
      const isDisabled =
        item.Status !== CommonStatusStep.Pending ||
        (item.Status === CommonStatusStep.Pending &&
          item.Deployed !== CommonStatusStep.Pending);
      return (
        item.GameID === selectItem?.GameID &&
        item.EnvID === selectItem?.EnvID &&
        isG6 &&
        !isDisabled &&
        item.FeeOrderApproved === null &&
        !getDisabled(serviceItem?.Pic)
      );
    });
  };

  const onSelectChange = (
    newSelectedRowKeys: readonly number[] | readonly string[]
  ) => {
    // 获取筛选后可选的数据项
    const selectableItems = getSelectableItems(filteredServiceList);
    const currentList =
      filteredServiceList.length > 0 ? filteredServiceList : serviceList;

    // 单个checkbox点击
    if (
      newSelectedRowKeys.length !== currentList.length ||
      selectedRowKeys.length === 0
    ) {
      if (newSelectedRowKeys.length > 0) {
        const dataItem = serviceList.find(
          (item) => item.id === newSelectedRowKeys[0]
        );
        if (dataItem) {
          setSelectGameAndEnv({
            gameId: dataItem.GameID,
            envId: dataItem.EnvID,
            studioId: dataItem.StudioID,
          });
        }
      } else if (newSelectedRowKeys.length === 0) {
        setSelectGameAndEnv({});
      }
    }
    // 全选功能
    if (
      selectedRowKeys.length !== 0 &&
      newSelectedRowKeys.length === currentList.length
    ) {
      const selectAbled =
        selectableItems.length > 0
          ? selectableItems
          : getSelectableItems(serviceList);
      // 已经选中了当前所有可选值再点击则去除
      if (selectAbled && selectAbled.length === selectedRowKeys.length) {
        setSelectedRowKeys([]);
        setSelectGameAndEnv({});
      } else if (selectAbled && selectAbled.length > 0) {
        setSelectedRowKeys(selectAbled.map((item) => item.id));
      }
    } else {
      setSelectedRowKeys(newSelectedRowKeys.map((key) => Number(key)));
    }
  };

  const clickReject = (record?: IAPIServicesApproveItem) => {
    if (record) {
      setSelectedRowKey(record.id);
    }
    setShowRejectModal(true);
  };

  const closeRejectModal = () => {
    setSelectedRowKey(undefined);
    setShowRejectModal(false);
  };

  const viewApproveDetails = (record: IAPIServicesApproveItem) => {
    setSelectedRowKey(record.id);
    const dataItem = serviceList.find((item) => item.id === record.id);
    if (dataItem) {
      setSelectGameAndEnv({
        gameId: dataItem.GameID,
        envId: dataItem.EnvID,
        studioId: dataItem.StudioID,
      });
    }
    setDrawerType(DrawerType.View);
    setShowG6ResolveModal(true);
  };

  // 同意
  const approveOk = (record: IAPIServicesApproveItem) => {
    setSelectedRowKey(record.id);
    const serviceItem = servicesConfig.find(
      (item) => item.Name === record.ServiceName
    );
    const dataItem = serviceList.find((item) => item.id === record.id);
    if (dataItem) {
      setSelectGameAndEnv({
        gameId: dataItem.GameID,
        envId: dataItem.EnvID,
        studioId: dataItem.StudioID,
      });
    }
    if (serviceItem && serviceItem?.Business === ServiceBusiness.G6) {
      setDrawerType(DrawerType.Approve);
      setShowG6ResolveModal(true);
    } else {
      setShowResolveModal(true);
    }
  };
  // 拒绝
  const rejectOk = async (
    selectedRowKeys: number[],
    status: CommonStatusStep
  ) => {
    // 同一个游戏同一环境下的g6服务才能批量审批
    const serviceItem = serviceList.find(
      (item) => item.id === selectedRowKeys[0]
    );
    const serviceItems = serviceList.filter((item) =>
      selectedRowKeys.includes(item.id)
    );
    const allRelatedApproveIds = uniq(
      serviceItems.map((item) => item.relatedApproveIds || [item.id]).flat()
    );
    if (serviceItem) {
      setLoading(true);
      // let envType = '';
      // const result = await wrapRequestArea(
      //   () => fetchAdminEnvList(serviceItem.GameID),
      //   site
      // );
      // if (result) {
      //   const envItem = result.find((item) => item.id === serviceItem.EnvID);
      //   envType = envItem?.Type || '';
      // }
      const envType = serviceItem.EnvItem?.Type || '';

      const body = {
        recordIds: allRelatedApproveIds,
        status,
        expectedAmount: 0,
        rejectReason: 'reject',
        envType,
      };
      batchCommitApply(body);
      // commitApply(selectedRowKeys, status, 'reject');
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      return true;
    }
    return false;
  };

  const closeBatchDrawer = () => {
    setDrawerType(null);
    setIsShowBatchDrawer(false);
    setShowResolveModal(false);
    setShowG6ResolveModal(false);
    setSelectGameAndEnv({});
    setSelectedRowKey(undefined);
  };

  // 批量审批
  const batchCommitApply = async (body: IServiceBatchApprovalParams) => {
    const currentBody = {
      recordIds: body.recordIds || [],
      status: body.status,
      expectedAmount: body.expectedAmount,
      envType: body.envType,
      rejectReason: body.rejectReason || '',
      projectCode: body.projectCode || '',
      chartVersion: body.chartVersion || '',
      enableBianque: body.enableBianque || false,
      enableAccess: body.enableAccess || false,
      reportGateway: body.reportGateway || false,
      g6DomainURL: body.g6DomainURL || '',
      isNoDeployEnabled: body.isNoDeployEnabled || false,
    };
    const res = await putServiceBatchApproval(currentBody);
    if (res?.code === 0) {
      messageSuccess(getFormatMessage('operation_success'));
      closeRejectModal();
      setSelectedRowKeys([]);
      getApprovalList();
      closeBatchDrawer();
    } else if (res?.code === 101868) {
      if (res?.data && res?.data?.code && res?.data?.msg) {
        messageError(
          getFormatMessage(`code: ${res?.data?.code}, msg: ${res?.data?.msg}`)
        );
      } else {
        messageError(getFormatMessage('operation_failed'));
      }
    } else if (res?.code === 101884) {
      messageError('批量服务审批，免部署流程，不存在回调域名（ingame）');
    } else {
      messageError(getFormatMessage('operation_failed'));
    }
  };

  useEffect(() => {
    getApprovalList();
  }, []);

  const noDeployOk = async () => {
    if (childRef.current?.onClickOk) {
      setShowNoDeployConfirmModal(false);
      await childRef.current.onClickOk(true);
      return true;
    }
    return false;
  };

  const renderNoDeployConfirmModal = () => {
    if (showNoDeployConfirmModal) {
      return (
        <ModalWrap
          onClose={() => setShowNoDeployConfirmModal(false)}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('confirm')}
          title="免部署开通"
          onOk={noDeployOk}
        >
          <div>
            通过后将立即为用户开启服务页面入口，是否确认免服务部署开通当前申请服务？
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderRejectModal = () => {
    const serviceItem = serviceList.find((item) => {
      // selectedRowKey存在则是单个拒绝
      if (selectedRowKey) {
        return item.id === selectedRowKey;
      }
      return item.id === selectedRowKeys[0];
    });
    if (showRejectModal && serviceItem) {
      const recordList: IAPIServicesApproveItem[] = [];
      if (selectedRowKey) {
        recordList.push(serviceItem);
      } else {
        selectedRowKeys.forEach((item) => {
          const selectedItem = serviceList.find((it) => it.id === item);
          if (selectedItem) {
            recordList.push(selectedItem);
          }
        });
      }
      return (
        <ModalWrap
          onClose={closeRejectModal}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('confirm')}
          onOk={() =>
            rejectOk(
              selectedRowKey ? [selectedRowKey] : selectedRowKeys,
              CommonStatusStep.Reject
            )
          }
        >
          <div>
            <div>{`是否确认驳回【${serviceItem.GameName || ''}】- 【${
              serviceItem.EnvItem?.Name || ''
            }】的服务开通申请？`}</div>
            <div>申请服务：</div>
            {recordList.map((item) => {
              const subService = item.SubServiceName
                ? `(${item.SubServiceName})`
                : '';
              return <div>{`${item.ServiceName} ${subService}`}</div>;
            })}
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderDefaultOperate = (
    _val: any,
    record: IAPIServicesApproveItem
  ): React.ReactNode => {
    if (record.FeeOrderApproved === CommonStatusStep.Pending) {
      return null;
    }
    const text: ApplyServiceStatus = JSON.parse(JSON.stringify(record.Status));
    const serviceItem = servicesConfig.find(
      (item) => item.Name === record.ServiceName
    );
    if (
      (getFormatServiceStatus(text, record) === ApplyServiceStatus.Resolve ||
        getFormatServiceStatus(text, record) ===
          ApplyServiceStatus.Processing) &&
      serviceItem &&
      serviceItem.Business === ServiceBusiness.G6
    ) {
      return (
        <Space
          size="middle"
          className={classnames(
            'operate-btn',
            record.ApprovalPayload ? '' : 'none'
          )}
        >
          <div className="webkit-box flex-left">
            <a
              style={{ color: '#5764f1', marginRight: '8px' }}
              onClick={() => viewApproveDetails(record)}
            >
              审批详情
            </a>
          </div>
        </Space>
      );
    }
    return (
      <Space
        size="middle"
        className={classnames(
          'operate-btn',
          record.Status === CommonStatusStep.Pending &&
            record.Deployed === CommonStatusStep.Pending
            ? ''
            : 'none'
        )}
      >
        {getDisabled(serviceItem?.Pic) ? (
          <div className="webkit-box flex-left">
            <a
              style={{
                color: '#acbaf9',
                marginRight: '8px',
                cursor: 'not-allowed',
              }}
            >
              {getFormatMessage('approve')}
            </a>

            <a style={{ color: '#acbaf9', cursor: 'not-allowed' }}>
              {getFormatMessage('reject')}
            </a>
          </div>
        ) : (
          <div className="webkit-box flex-left">
            <a
              style={{ color: '#5764f1', marginRight: '8px' }}
              onClick={() => approveOk(record)}
            >
              {getFormatMessage('approve')}
            </a>

            <a style={{ color: '#5764f1' }} onClick={() => clickReject(record)}>
              {getFormatMessage('reject')}
            </a>
          </div>
        )}
      </Space>
    );
  };

  const COLUMNS: ColumnType<IAPIServicesApproveItem>[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
      fixed: 'left',
    },
    {
      title: `${getFormatMessage('title_name')} (${getFormatMessage(
        'title_id'
      )})`,
      dataIndex: 'GameID',
      key: 'GameID',
      width: 200,
      fixed: 'left',
      render: (text: string, record: IAPIServicesApproveItem) => {
        return (
          <CustomPopover content={`${record.GameName} (${text})`}>
            <span>{`${record.GameName} (${text})`}</span>
          </CustomPopover>
        );
      },
    },
    {
      title: `${getFormatMessage('env_name')} (${getFormatMessage(
        'admin_env_type'
      )})`,
      dataIndex: 'EnvItem',
      key: 'EnvName',
      fixed: 'left',
      width: 180,
      render: (record) => {
        const name = record?.Name || '';
        const type = record?.Type || '';
        return (
          <CustomPopover
            content={
              <span>
                <span>{name}</span>
                {renderEnvTypeTag(type)}
              </span>
            }
          >
            <span>
              <span>{name}</span>
              {renderEnvTypeTag(type)}
            </span>
          </CustomPopover>
        );
      },
    },
    {
      title: getFormatMessage('admin_apply_service'),
      dataIndex: 'ServiceName',
      key: 'ServiceName',
      width: 220,
      render: (text: string, record: IAPIServicesApproveItem) => {
        const subService = record.SubServiceName
          ? `(${record.SubServiceName})`
          : '';
        return (
          <CustomPopover content={`${text} ${subService}`}>
            <span>{`${text} ${subService}`}</span>
          </CustomPopover>
        );
      },
    },
    {
      title: getFormatMessage('admin_region'),
      dataIndex: 'EnvItem',
      key: 'EnvItem',
      width: 130,
      render: (record) => {
        const region = record?.Region || '';
        const regionName = getEnvNameByValue(region);
        return <span>{regionName}</span>;
      },
    },
    {
      title: getFormatMessage('admin_studio_info'),
      dataIndex: 'StudioName',
      key: 'StudioName',
      width: 220,
      render: (text: string, record: IAPIServicesApproveItem) => {
        return (
          <CustomPopover
            content={
              <span>
                {text}({record.StudioID})
              </span>
            }
          >
            <span>
              {text}({record.StudioID})
            </span>
          </CustomPopover>
        );
      },
    },
    {
      title: getFormatMessage('admin_applicant'),
      dataIndex: 'Applicant',
      key: 'Applicant',
      width: 140,
    },
    {
      title: getFormatMessage('admin_applicant_time'),
      dataIndex: 'CreateTime',
      key: 'CreateTime',
      width: 180,
      render: (text: Date) => {
        return getLocalTime(text, userInfo?.UserSettings?.Timezone);
      },
      sorter: (a: any, b: any) => {
        const dateA = moment(a.CreateTime);
        const dateB = moment(b.CreateTime);
        return dateA.diff(dateB);
      },
    },
    {
      title: getFormatMessage('admin_modify_time'),
      dataIndex: 'ModifyTime',
      key: 'ModifyTime',
      width: 180,
      render: (text: Date) => {
        return getLocalTime(text, userInfo?.UserSettings?.Timezone);
      },
      sorter: (a: any, b: any) => {
        const dateA = moment(a.CreateTime);
        const dateB = moment(b.CreateTime);
        return dateA.diff(dateB);
      },
    },
    {
      title: getFormatMessage('admin_approver'),
      dataIndex: 'ApproverUid',
      key: 'ApproverUid',
      width: 140,
      render: (text: string) => {
        if (!text) {
          return '/';
        }
        return getUserNameBySite(text, site);
      },
    },
    {
      title: getFormatMessage('admin_result'),
      dataIndex: 'Status',
      key: 'Status',
      fixed: 'right',
      width: 80,
      render: (text: ApplyServiceStatus, record: IAPIServicesApproveItem) => {
        const newStatus = getFormatServiceStatus(text, record);
        return getServiceStatusLabel(newStatus);
      },
    },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      fixed: 'right',
      width: 120,
      render: renderDefaultOperate,
    },
  ];
  const rowSelection = {
    rowKey: 'id',
    selectedRowKeys,
    onChange: onSelectChange,
    // hideSelectAll: true,
    getCheckboxProps: (record?: IAPIServicesApproveItem) => {
      if (!record) {
        if (selectedRowKeys.length !== 0) {
          const selectItem = serviceList.find(
            (item) => item.id === selectedRowKeys[0]
          );
          const selectAbled = serviceList.filter((item) => {
            const serviceItem = servicesConfig.find(
              (it) => it.Name === item.ServiceName
            );
            const isG6 = serviceItem?.Business === ServiceBusiness.G6;
            const isDisabled =
              item.Status !== CommonStatusStep.Pending ||
              (item.Status === CommonStatusStep.Pending &&
                item.Deployed !== CommonStatusStep.Pending);
            return (
              item.GameID === selectItem?.GameID &&
              item.EnvID === selectItem?.EnvID &&
              isG6 &&
              !isDisabled &&
              item.FeeOrderApproved === null &&
              !getDisabled(serviceItem.Pic)
            );
          });
          if (selectAbled && selectAbled.length !== 0) {
            return {
              indeterminate: isAllSelectIndeterminate,
              checked: isAllSelectChecked,
            };
          }
        }
        return {
          disabled: true,
        };
      }
      let isG6 = false;
      let isDisabled = false;
      const serviceItem = servicesConfig.find(
        (item) => item.Name === record.ServiceName
      );
      if (serviceItem && serviceItem.Business === ServiceBusiness.G6) {
        isG6 = true;
      }
      if (selectGameAndEnv.gameId && selectGameAndEnv.envId) {
        if (
          selectGameAndEnv.gameId !== record.GameID ||
          selectGameAndEnv.envId !== record.EnvID
        ) {
          isDisabled = true;
        }
      }
      if (
        record.Status !== CommonStatusStep.Pending ||
        (record.Status === CommonStatusStep.Pending &&
          record.Deployed !== CommonStatusStep.Pending)
      ) {
        isDisabled = true;
      }

      const tips =
        !isG6 && record.Status === CommonStatusStep.Pending
          ? getFormatMessage('cannot_batch_approval')
          : '';

      return {
        disabled:
          record.FeeOrderApproved !== null ||
          !isG6 ||
          isDisabled ||
          getDisabled(serviceItem?.Pic),
        tips,
      };
    },
  };

  const selectedRows = serviceList.filter((serviceItem) =>
    selectedRowKeys.includes(serviceItem.id)
  );
  const selectedRow = serviceList.find(
    (serviceItem) => serviceItem.id === selectedRowKey
  );

  return (
    <div>
      <AutoAntTable
        loading={loading}
        dataSource={serviceList || []}
        rowSelection={rowSelection}
        columns={COLUMNS}
        // locale={{ emptyText: 'There are no pending invitations.' }}
        showTotal={(total) => {
          return (
            <>
              {!!selectedRowKeys.length && (
                <span>
                  {getFormatMessage('select_items', {
                    params: {
                      count: selectedRowKeys.length,
                    },
                  })}
                </span>
              )}
              <span>
                {getFormatMessage('total_items', {
                  params: {
                    total,
                  },
                })}
              </span>
            </>
          );
        }}
        configFilter={{
          filters: [
            {
              type: 'select',
              name: 'Status',
              label: '处理状态',
              className: 'service-select-status',
              options: getApplyServiceStatusOptions(),
              filter(filterVal: ApplyServiceStatus, record) {
                if (!filterVal && filterVal !== ApplyServiceStatus.Pending) {
                  return true;
                }

                if (
                  record.Status === CommonStatusStep.Pending &&
                  record.Deployed === CommonStatusStep.Resolve
                ) {
                  return filterVal === ApplyServiceStatus.Processing;
                }

                return Number(filterVal) === Number(record.Status);
              },
            },
            {
              type: 'select',
              name: 'Type',
              label: '环境类型',
              className: 'service-select-status',
              options: getEnvTypeOptions(),
              filter(val, record) {
                return !val || record.EnvItem?.Type === val;
              },
            },
            {
              type: 'text',
              name: 'ServiceName',
              label: '服务名称',
              className: 'service-select-status',
            },
            {
              type: 'text',
              name: 'id',
              label: '单据ID',
              className: 'service-select-status',
            },
            {
              type: 'text',
              name: 'GameID',
              label: '游戏名称/ID',
              className: 'service-input-game',
              filter: (val, record) => {
                return (
                  !val ||
                  `${record.GameName}${record.GameID}`
                    .toLowerCase()
                    .includes(String(val).toLowerCase())
                );
              },
            },
            {
              type: 'text',
              name: 'EnvName',
              label: '环境名称',
              className: 'service-select-status',
              filter(val, record) {
                return (
                  !val ||
                  record.EnvItem?.Name.toLowerCase().includes(
                    String(val).toLowerCase()
                  )
                );
              },
            },
            {
              type: 'clear-btn',
              name: 'clear',
              label: '清除筛选',
            },
            {
              name: 'right',
              place: 'right',
              render() {
                const isAnyRowSelected = selectedRowKeys.length > 0;
                return (
                  <>
                    {/* <div className="notify-button">
                      <Notify site={site} />
                    </div> */}
                    {/* <button className="piliang"> */}
                    <Select value="批量操作">
                      <Select.Option>
                        <a
                          style={{ color: '#5764f1' }}
                          className={`${
                            !isAnyRowSelected ? 'disabled-drop-title' : ''
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!isAnyRowSelected) {
                              return;
                            }
                            if (selectedRowKeys.length > 0) {
                              const dataItem = serviceList.find(
                                (item) => item.id === selectedRowKeys[0]
                              );
                              if (dataItem) {
                                setSelectGameAndEnv({
                                  gameId: dataItem.GameID,
                                  envId: dataItem.EnvID,
                                  studioId: dataItem.StudioID,
                                });
                              }
                            } else if (selectedRowKeys.length === 0) {
                              setSelectGameAndEnv({});
                            }
                            setDrawerType(DrawerType.Approve);
                            setIsShowBatchDrawer(true);
                          }}
                        >
                          {getFormatMessage('batch_approve')}
                        </a>
                      </Select.Option>
                      <Select.Option>
                        <a
                          style={{ color: '#5764f1' }}
                          className={`${
                            !isAnyRowSelected ? 'disabled-drop-title' : ''
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!isAnyRowSelected) {
                              return;
                            }
                            clickReject();
                          }}
                        >
                          {getFormatMessage('batch_reject')}
                        </a>
                      </Select.Option>
                    </Select>
                    {/* <Dropdown
                        overlay={<CustomDropdownOverlay />}
                        trigger={['click']}
                      >
                        <a
                          className="ant-dropdown-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          <MoreOutlined />
                        </a>
                      </Dropdown> */}
                    {/* </button> */}
                  </>
                );
              },
            },
          ],
          onChange: (_values, _changeField, filterList) => {
            setFilteredServiceList(filterList);
          },
        }}
      />
      {showResolveModal && (
        <ServiceResolveModal
          site={site}
          isFeeEnabled={isFeeEnabled}
          singleService={selectedRow}
          batchServices={selectedRows}
          onSuccess={() => {
            setSelectedRowKey(undefined);
            setSelectedRowKeys([]);
            setShowResolveModal(false);
            getApprovalList();
            setSelectGameAndEnv({});
          }}
          onCancel={() => {
            setSelectedRowKey(undefined);
            setSelectedRowKeys([]);
            setShowResolveModal(false);
            setSelectGameAndEnv({});
          }}
          selectedRowKey={selectedRowKey}
          serviceList={serviceList}
        />
      )}

      <BatchDrawer
        site={site}
        visible={isShowBatchDrawer || showG6ResolveModal}
        onClose={closeBatchDrawer}
        onOk={batchCommitApply}
        selectedRowKeys={
          showG6ResolveModal && selectedRowKey
            ? [selectedRowKey]
            : selectedRowKeys
        }
        serviceList={serviceList}
        selectGameAndEnv={selectGameAndEnv}
        type={drawerType}
        showConfirm={setShowNoDeployConfirmModal}
        gameList={gameList}
        ref={childRef}
      />

      {renderRejectModal()}
      {renderNoDeployConfirmModal()}
    </div>
  );
};
